export default navigator && /Firefox/i.test(navigator.userAgent);
